<ng-container *ngIf="(settings$ | async) as settings">

  <global-svg-sprite></global-svg-sprite>

  <div [innerHTML]="brandStyles(settings)"></div>

  <affiliate-cookie-tracking></affiliate-cookie-tracking>

  <third-party-scripts-injector></third-party-scripts-injector>

  <google-analytics-integration></google-analytics-integration>

  <facebook-integration></facebook-integration>

  <paypal-integration></paypal-integration>

  <instructor-chat></instructor-chat>

  <wait-for-platform-lifetime-purchase></wait-for-platform-lifetime-purchase>

  <rewardful-integration></rewardful-integration>

  <source-tracking></source-tracking>

  <mix-panel-integration></mix-panel-integration>

  <ng-container *ngIf="settings?.sessionLanguage">

    <div class="top-menu-container">
      <!--top-discount-banner *ngIf="settings?.showTopBanner"></top-discount-banner-->
      <top-menu *ngIf="!isPlatformLogin"></top-menu>
    </div>

    <div class="app-messages-container">
      <messages></messages>
    </div>

    <ai-global-chat></ai-global-chat>

    <main> <!--[style.padding-top.px]="settings?.showTopBanner ? 65 : 0"-->
      <router-outlet></router-outlet>
    </main>

  </ng-container>

  <loading [detectLazyLoading]="true"></loading>

</ng-container>

<!-- <span class="load-font material-symbols-outlined">play_arrow</span>

<span class=" load-font material-symbols-outlined">delete</span> -->


